import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'safeNumber',
})
export class SafeNumberPipe implements PipeTransform {
  private decimalPipe = inject(DecimalPipe);

  transform(value: number | string | null | undefined, args?: string): string {
    const numericValue = Number(value);
    return this.decimalPipe.transform(Number.isNaN(numericValue) ? 0 : numericValue, args);
  }
}